import { Injectable } from '@angular/core';
import { GalleryItem, ImageItem } from 'ng-gallery';

@Injectable({
  providedIn: 'root'
})
export class GalleryService {
  public images: GalleryItem[] = [];

  formatImages(urls: string[]): GalleryItem[] {
    return urls.map(url => new ImageItem({ src: url, thumb: url }));
  }

  openGallery(images: GalleryItem[]): void {
    this.images = images;
  }
}
